jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$('p iframe[src*="youtube.com"]').wrap('<div class="youtube-video"></div>');

$(function () {
  var $temperature = $("[data-temperature-value]");

  if ($temperature.length === 0) {
    return;
  }

  var endpoint = $temperature.first().data("temperature-url");

  if (!endpoint) {
    return;
  }

  $temperature.each(function () {
    var $node = $(this);
    $node.data(
      "temperature-original-html",
      $node.find("[data-temperature-content]").html()
    );
  });

  $temperature.addClass("is-loading");

  $.get(endpoint)
    .done(function (response) {
      if (!response || response.value === undefined) {
        $temperature.removeClass("is-loading");
        return;
      }

      if (response.available) {
        $temperature.find("[data-temperature-content]").html(
          response.value + ' <span>' + response.unit + "</span>"
        );
      } else {
        $temperature.find("[data-temperature-content]").text(response.value);
      }

      $temperature.removeClass("is-loading");
    })
    .fail(function () {
      $temperature.each(function () {
        var $node = $(this);
        $node.find("[data-temperature-content]").html(
          $node.data("temperature-original-html")
        );
      });
      $temperature.removeClass("is-loading");
    });
});

/**** Main menu ****/

$(document).on("click", function (event) {
  if (!$(event.target).closest("#lang, .lang-active").length) {
    $("#lang").removeClass("open-lang");
  }
});

$(".lang-active").on("click", function (event) {
  event.stopPropagation();
  $("#lang").toggleClass("open-lang");

  if ($("#lang").hasClass("open-lang")) {
    $(".lang-active").attr("aria-expanded", "true");
  } else {
    $(".lang-active").attr("aria-expanded", "false");
  }
});

$(".dropdown-toggle").dropdown();

function checkWidth() {
  if ($(window).width() < 975) {
    $(".navi li ul").hide();
  } else {
    $(".navi li ul").attr("style", "");
  }
}

checkWidth();

$(window).on("resize", function () {
  checkWidth();
  $("a.colapse").hide();
  $("a.expand").show();
});

// $(".navi li").each(function () {
//   var li = $(this);
//   if (li.find("ul li").length > 0) {
//     li.append(
//       "<a href='javascript:;' rel='nofollow noopener' class='expand icon-expand' onclick='return false;'></a>"
//     );
//     li.append(
//       "<a href='javascript:;' rel='nofollow noopener' class='colapse icon-collapse' onclick='return false;'></a>"
//     );
//   }
// });

$("body").on("click", "a.expand", function () {
  $(this).hide().next().show();
  $(this).parent().siblings().find("ul").slideUp();
  $(this).parent().siblings().find("a.expand").show();
  $(this).parent().siblings().find("a.colapse").hide();
  $(this)
    .parent()
    .find(">ul")
    .addClass("expanded")
    .stop(true, true)
    .slideDown();
});

$("body").on("click", "a.colapse", function () {
  $(this)
    .parent()
    .find("ul")
    .removeClass("expanded")
    .stop(true, true)
    .slideUp();
  $(this).parent().find("a.colapse").hide();
  $(this).parent().find("a.expand").show();
});

// $(".hamburger").on("click", function () {
//   $(".hamburger").toggleClass("is-active");
//   $(".header-container").toggleClass("navi-open");
//   $(".navigation-wrapper").toggleClass("navi-open");
//   $("body").toggleClass("navi-open");
// });

var searchWrapper = $(".search-form-wrapper");
var searchInput = $(".search-form-wrapper .search-input");
var searchIcon = $(".search-toggle");
searchIcon.on("click", function () {
  searchWrapper.toggleClass("show");

  if (searchWrapper.hasClass("show")) {
    searchInput.focus();
    searchIcon.attr("aria-expanded", "true");
  } else {
    searchIcon.attr("aria-expanded", "false");
    searchInput.blur();
  }
});

var resizedTimes = 0;
function resizeIframe(height, id) {
  var new_height = parseInt(height);
  $("#" + id).css("height", new_height);
}
$("li.level1 .show-more").on("click", function () {
  $(this).toggleClass("asd");
});
/*** Accessibility menu start ***/

$(function () {
  // ======== INITIAL SETUP ========
  function initTabIndex() {
    if ($(window).width() < 1200) {
      // Mobile: everything inside navigation-wrapper untabbable
      $(".navigation-wrapper")
        .find(
          "a.level1, a.level2, a.level3, a.level4, .show-more, .search-toggle, #lang a",
        )
        .attr("tabindex", -1);

      $("ul.level1").show(); // top-level menu always visible
    } else {
      // Desktop: top-level links tabbable, submenu initially not
      $("a.level1").attr("tabindex", 0);
      $("ul.level1").show();
      $("ul[class*='level'] a:not(.level1)").attr("tabindex", -1);
      $(".show-more, .search-toggle, #lang a").attr("tabindex", 0);
    }
  }

  initTabIndex();
  $(window).on("resize", initTabIndex);

  // ======== HAMBURGER CLICK ========
  $(".navbar-button").on("click", function () {
    $(".hamburger").toggleClass("is-active");
    $(".header-container, .navigation-wrapper, body").toggleClass("navi-open");

    if ($(window).width() < 1200) {
      if ($("body").hasClass("navi-open")) {
        // Menu opened → top-level links, show-more, search, language tabbable
        $(".navigation-wrapper")
          .find("a.level1, .show-more, .search-toggle, #lang a")
          .attr("tabindex", 0);
        $("a.level2, a.level3, a.level4").attr("tabindex", -1);

        // Make all level1 links tabbable and focus the first one
        $("ul.level1 a.level1").attr("tabindex", 0);
        $("ul.level1 a.level1:first").focus();

        enableFocusTrap();
      } else {
        // Menu closed → all untabbable
        $(".navigation-wrapper")
          .find(
            "a.level1, a.level2, a.level3, a.level4, .show-more, .search-toggle, #lang a",
          )
          .attr("tabindex", -1);

        $(document).off("keydown.mobileTrap");
      }
    }
  });

  // ======== SHOW-MORE CLICK ========
  $(".show-more").on("click", function () {
    var $li = $(this).closest("li");
    var $submenu = $li.children("ul");

    $li.toggleClass("active-menu");

    if ($(window).width() < 1200) {
      $submenu.toggle("slow", function () {
        if ($("body").hasClass("navi-open")) enableFocusTrap();
      });
    } else {
      $submenu.toggleClass("open-level");
    }

    var expanded =
      $li.hasClass("active-menu") || $submenu.hasClass("open-level");
    $submenu.attr("aria-expanded", expanded ? "true" : "false");
    $submenu.find("a").attr("tabindex", expanded ? 0 : -1);
  });

  // ======== FOCUSOUT HANDLER ========
  $("ul[class*='level']").on("focusout", function (event) {
    var $ul = $(this);

    if (!event.relatedTarget || !$ul.has(event.relatedTarget).length) {
      $ul.removeClass("open-level active-menu");
      $ul.find("a").attr("tabindex", -1);
      $ul.attr("aria-expanded", "false");

      if ($(window).width() < 1200 && !$ul.is(".level1")) {
        $ul.hide("slow", function () {
          if ($("body").hasClass("navi-open")) enableFocusTrap();
        });
      }
    }
  });

  // ======== MOBILE FOCUS TRAP ========
  function enableFocusTrap() {
    $(document)
      .off("keydown.mobileTrap")
      .on("keydown.mobileTrap", function (e) {
        var $container = $(".navigation-wrapper");
        var $focusable = $container.find(
          'a:visible, button:visible, [tabindex="0"]:visible',
        );

        if ($focusable.length === 0) return;

        var firstEl = $focusable.first()[0];
        var lastEl = $focusable.last()[0];

        if (e.key === "Tab") {
          if (e.shiftKey) {
            if (document.activeElement === firstEl) {
              e.preventDefault();
              lastEl.focus();
            }
          } else {
            if (document.activeElement === lastEl) {
              e.preventDefault();
              firstEl.focus();
            }
          }
        } else if (e.key === "Escape") {
          // Close mobile menu
          if ($("body").hasClass("navi-open")) {
            $(".hamburger").removeClass("is-active");
            $(".header-container, .navigation-wrapper, body").removeClass(
              "navi-open",
            );

            // Reset tabindex
            $(".navigation-wrapper")
              .find(
                "a.level1, a.level2, a.level3, a.level4, .show-more, .search-toggle, #lang a",
              )
              .attr("tabindex", -1);

            // Remove focus trap
            $(document).off("keydown.mobileTrap");
          }
        }
      });
  }
});

/*** Accessibility menu end ***/
